import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, getFont } from '@tornado-rdk/typography';
import { makeDefaultStylingContext } from '../../../../utils/style';
import { identity, SCREEN_WIDTH } from '../../../../utils/sizes';
import { HEIGHT as BUTTON_HEIGHT } from '../../../../button/button.style';
import { SIZE as ARROW_SIZE } from '../../../../navigation-arrow/navigationArrow.style';
import { getLabelFont as getTabsFont } from '../../../selectors/selector/blockHeader/blockHeader.style';

export const defaultContext = makeDefaultStylingContext();

export const HEIGHT = {
  [HD]: 56,
  [FULL_HD]: 64,
};

export const TO_LIVE_MARGIN_RIGHT = {
  [HD]: 0,
  [FULL_HD]: 0,
};

export const GAP_RIGHT = 40;

export const GAP_LEFT = 56;

export const getTextStyle = screenSize => ({
  ...getFont(FONT.BERLIN_2, screenSize),
  verticalAlign: 'middle',
});

export const getInitialStyle = ({ screenSize } = defaultContext) => {
  const arrowsWidth = ARROW_SIZE[screenSize] * 2 + GAP_RIGHT;
  const buttonY = Math.round((HEIGHT[screenSize] - BUTTON_HEIGHT[screenSize]) / 2);

  return {
    h: HEIGHT[screenSize],
    LeftContainer: {
      w: SCREEN_WIDTH[screenSize],
      flex: {
        direction: 'row',
      },
      DateSelector: {
        y: buttonY,
      },
      Tabs: {
        w: identity,
        y: Math.round((HEIGHT[screenSize] - getTabsFont(screenSize).lineHeight) / 2),
        flexItem: {
          grow: 1,
          marginLeft: GAP_LEFT,
        },
      },
    },
    ToLive: {
      mountX: 1,
      x: v => v - arrowsWidth - TO_LIVE_MARGIN_RIGHT[screenSize] - GAP_RIGHT,
      y: buttonY,
    },
    Arrows: {
      w: arrowsWidth,
      mountX: 1,
      x: identity,
      ArrowRight: {
        x: ARROW_SIZE[screenSize] + GAP_RIGHT,
      },
    },
  };
};
